import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, ShieldCheck, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const checkoutUrl = 'https://noveliahub.com/cart/44193210630180:1';
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden bg-cream" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-101">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-102">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-103">
            <span className="inline-block py-1 px-3 rounded-full bg-sage-100 text-sage-800 text-xs font-semibold tracking-widest uppercase mb-6" data-id="element-104">
              El Programa Integral
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-charcoal" data-id="element-105">
              ¿Sientes que tu cuerpo cambió sus reglas y nadie te dio el nuevo
              manual?
            </h1>

            <p className="text-lg md:text-xl text-charcoal-light mb-8 leading-relaxed" data-id="element-106">
              Recupera tu energía, desinflama tu abdomen y calma tus noches con{' '}
              <strong className="font-semibold text-sage-700" data-id="element-107">
                Vuelve a Sentirte Tú: Menopause Reset
              </strong>
              . El programa integral de 15 módulos diseñado para la mujer
              moderna.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-108">
              <Button href={checkoutUrl} className="w-full sm:w-auto text-lg" data-id="element-109">
                SÍ, QUIERO MI RESET AHORA
              </Button>
            </div>

            {/* Trust Signals */}
            <div className="flex flex-wrap items-center gap-4 md:gap-6 text-sm text-charcoal-light font-medium" data-id="element-110">
              <div className="flex items-center gap-1.5" data-id="element-111">
                <CheckCircle2 size={18} className="text-sage-600" data-id="element-112" />
                <span data-id="element-113">15 módulos</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-114">
                <Leaf size={18} className="text-sage-600" data-id="element-115" />
                <span data-id="element-116">Método natural</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-117">
                <ShieldCheck size={18} className="text-sage-600" data-id="element-118" />
                <span data-id="element-119">Garantía 7 días</span>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:ml-auto" data-id="element-120">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-121">
              <img src="https://cdn.magicpatterns.com/uploads/j5LTCrewsSNVvz1HU9pc69/Mockup_2.png" alt="Vuelve a Sentirte Tú - Menopause Reset Program Mockup on Tablet and Phone" className="w-full h-auto object-cover" data-id="element-122" />
            </div>
            {/* Decorative background blob */}
            <div className="absolute -inset-4 bg-sage-100 rounded-[3rem] -z-10 transform rotate-3 scale-105 opacity-50 blur-xl" data-id="element-123"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}